module.exports = __webpack_public_path__ + "img/5.0a1a6eec.png";